import { UserRequester } from '@cobliteam/api-lib';
import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import { Environment } from '@cobliteam/react-environments/src/Environments';
import { Button } from '@cobliteam/ui/components';
import { useMemo, useState } from 'react';

const REQUIRED_PERMISSIONS = ['create-update-delete:users-and-invites', 'cobler:admin', 'basic:permission'];

const env = Environment.getInstance().getEnvironment();
const userRequester = new UserRequester({ host: env.herbieApiHost });

const Permissions = () => {
  const [loading, setLoading] = useState(false);
  const { getUser, getDefaultRoles } = useUser();
  const user = getUser();
  const { data: defaultRoles } = getDefaultRoles();

  const [selectedUserPermissions, setSelectedUserPermissions] = useState<string[]>(user.grantedPermissions);

  const handlePermissionChange = (permission: string) => {
    setSelectedUserPermissions((prev) => (prev.includes(permission) ? prev.filter((p) => p !== permission) : [...prev, permission]));
  };

  const saveUserPermissions = (permissions: string[]) => {
    setLoading(true);
    userRequester
      .saveUserPermissions(user.id, user.role, [], [...permissions, ...REQUIRED_PERMISSIONS])
      .then(() => {
        window.location.reload();
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  const allPermissions = useMemo(() => new Set<string>((defaultRoles || []).flatMap((role) => role.permissions)), [defaultRoles]);

  const isCobler = user.role === 'cobler';

  return (
    <div className='w-full'>
      <div className='flex justify-between gap-2'>
        <div>
          <h3 className='font-semibold text-lg'>Permissões</h3>
          {isCobler && <p className='text-red-500'>Cobler tem permissões especiais!</p>}
        </div>
        <div className='mt-4 flex gap-2'>
          <Button onClick={() => saveUserPermissions(selectedUserPermissions)} disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar'}
          </Button>
        </div>
      </div>

      <div className='mt-4'>
        <label className='mb-4 flex items-center gap-2'>
          <input
            type='checkbox'
            checked={Array.from(allPermissions).every((p) => selectedUserPermissions.includes(p))}
            onChange={() => {
              if (Array.from(allPermissions).every((p) => selectedUserPermissions.includes(p))) {
                setSelectedUserPermissions([]);
              } else {
                setSelectedUserPermissions(Array.from(allPermissions));
              }
            }}
          />
          Selecionar todos
        </label>
        {Array.from(allPermissions).map((permission) => {
          return (
            <label key={permission} className='flex items-center gap-2'>
              <input
                type='checkbox'
                disabled={REQUIRED_PERMISSIONS.includes(permission)}
                checked={selectedUserPermissions.includes(permission)}
                onChange={() => handlePermissionChange(permission)}
              />
              {permission}
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default Permissions;
